export const ariaAttr = <T>(x: T) => x ?? undefined
